import React from 'react';
import { PermissionsUtil } from '../../../utils/permissions/PermissionsUtil';
import { PERMISSIONS } from '../../../constants/permissions/permissions.constants';
import SelectDropdown from '../../../components/Form/SelectDropdown/SelectDropdown';
import useIsActiveCellRenderer from '../hooks/ApprovalWorkflows/useIsActiveCellRenderer';

interface isActiveCellRendererProps {
    data: any;
    rowIndex: number;
}

const isActiveCellRenderer = ({
    data,
    rowIndex,
}: isActiveCellRendererProps) => {
    const { user, approvalWorkflows, updateWorkflow } = useIsActiveCellRenderer(
        { data, rowIndex }
    );

    return (
        <SelectDropdown
            isDisabled={
                !PermissionsUtil.isPermissionEnabled(
                    user.permissions,
                    PERMISSIONS.AP_AUTOMATION.APPROVAL_WORKFLOWS.UPDATE
                )
            }
            menuPortalTarget={document.getElementById(
                'approval-workflows-modal'
            )}
            menuPlacement={
                rowIndex >= approvalWorkflows.length / 2 ? 'top' : 'bottom'
            }
            value={data.isActive.toString()}
            options={[
                { value: true, label: 'Yes' },
                { value: false, label: 'No' },
            ]}
            onChange={updateWorkflow}
            menuPosition={'fixed'}
        />
    );
};

export default isActiveCellRenderer;
